<button
	class="ctb-button"
	[attr.aria-busy]="state().loading ? 'true' : null"
	[attr.aria-label]="resolvedAriaLabel()"
	[attr.data-size]="state().size"
	[attr.data-variant]="state().variant"
	[attr.id]="state().id"
	[disabled]="isDisabled()"
	[type]="state().type"
	(click)="onButtonClick($event)"
	(keydown)="onButtonKeyDown($event)"
	(keypress)="onButtonKeyPress($event)"
	(keyup)="onButtonKeyUp($event)"
>
	@if (state().loading) {
		<span aria-hidden="true" class="ctb-button__spinner"></span>
	}

	@if (state().label !== "") {
		<span class="ctb-button__content">{{ state().label }}</span>
	} @else {
		<ng-content />
	}
</button>
